import { render, staticRenderFns } from "./RoomRequestsModal.vue?vue&type=template&id=a9ab25fe&scoped=true&"
import script from "./RoomRequestsModal.vue?vue&type=script&lang=ts&"
export * from "./RoomRequestsModal.vue?vue&type=script&lang=ts&"
import style0 from "./RoomRequestsModal.vue?vue&type=style&index=0&id=a9ab25fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ab25fe",
  null
  
)

export default component.exports